import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const restrictedRoutes: RouteRecordRaw[] = [
  {
    path: "/not-authorized",
    name: "notAuthorized",
    component: () => import("@/views/restricted/NotAuthorizedView.vue"),
    meta: {
      layout: KeyAccountLayout,
      requiresAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dashboard",
  },
];

export default restrictedRoutes;
